import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
;
/**
 * Analytics Api: personalizationImpressionEvent.
 * @param {object} PersonalizationImpressionEventParams Object with the personalization impression event details.
 * @param {string} PersonalizationImpressionEventParams.elementName Name of element
 * @param {string} PersonalizationImpressionEventParams.elementPlacement Placement of element
 * @param {string} PersonalizationImpressionEventParams.product Product
 * @param {string} PersonalizationImpressionEventParams.category Category of event
 * @param {string} PersonalizationImpressionEventParams.elementContext Context of element
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { personalizationImpressionEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * personalizationImpressionEvent({
 *   elementName: "00000:0:0",
 *   elementPlacement: "2col-accounts-flex-default",
 *   elementContext: "failure",
 *   product: "tnt",
 *   category: "2"
 * });
 *
 * // With additional payload data
 * personalizationImpressionEvent({
 *   elementName: "00000:0:0",
 *   elementPlacement: "2col-accounts-flex-default",
 *   elementContext: "failure",
 *   product: "tnt",
 *   category: "2"
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function personalizationImpressionEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.PERSONALIZATION_IMPRESSION, params, customPayload);
}
